type Location = {
  name: string;
  address: string[];
  phone: string;
  phoneHref: string;
  fax: string;
  hours: { label: string; value: string }[];
  directionsHref: string;
};

const LOCATIONS: Location[] = [
  {
    name: "Fairfield Office",
    address: ["52 Beach Rd., #206", "Fairfield, CT 06824"],
    phone: "203-255-2677",
    phoneHref: "tel:2032552677",
    fax: "203-255-1659",
    hours: [
      { label: "Monday – Thursday", value: "8am – 5pm" },
      { label: "Friday – Sunday", value: "Closed" },
    ],
    directionsHref: "https://goo.gl/maps/WARQs8jNPvB2",
  },
  {
    name: "Orange Office",
    address: ["185 Boston Post Rd.", "Orange, CT 06477"],
    phone: "203-799-0600",
    phoneHref: "tel:2037990600",
    fax: "203-799-0550",
    hours: [
      { label: "Monday – Thursday", value: "8am – 5pm" },
      { label: "Friday – Sunday", value: "Closed" },
    ],
    directionsHref: "https://goo.gl/maps/HwjtNq3axNu",
  },
];

export default function Locations() {
  return (
    <section id="locations" className="bg-sage-700 text-cream-50">
      <div className="section">
        <div className="max-w-2xl">
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-blush-200">
            Two locations
          </p>
          <h2 className="mt-4 font-serif text-3xl text-cream-50 sm:text-4xl">
            Convenient care across Fairfield County.
          </h2>
          <p className="mt-5 text-cream-100/90">
            Whether you're closer to Fairfield or Orange, you'll find the same
            warm welcome and the same standard of care at both of our offices.
          </p>
        </div>

        <div className="mt-14 grid gap-8 lg:grid-cols-2">
          {LOCATIONS.map((loc) => (
            <article
              key={loc.name}
              className="rounded-2xl bg-sage-800/50 p-8 ring-1 ring-cream-50/10"
            >
              <h3 className="font-serif text-2xl text-cream-50">{loc.name}</h3>

              <div className="mt-6 space-y-5 text-sm">
                <Row label="Address">
                  <p className="text-cream-100/90">{loc.address[0]}</p>
                  <p className="text-cream-100/90">{loc.address[1]}</p>
                  <a
                    href={loc.directionsHref}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-2 inline-flex items-center gap-1 text-blush-200 hover:text-blush-100"
                  >
                    Get directions
                    <span aria-hidden="true">→</span>
                  </a>
                </Row>

                <Row label="Phone">
                  <a
                    href={loc.phoneHref}
                    className="font-serif text-lg text-cream-50 hover:text-blush-200"
                  >
                    {loc.phone}
                  </a>
                  <p className="mt-1 text-cream-100/70">Fax: {loc.fax}</p>
                </Row>

                <Row label="Hours">
                  <ul className="space-y-1.5">
                    {loc.hours.map((h) => (
                      <li
                        key={h.label}
                        className="flex justify-between gap-6 text-cream-100/90"
                      >
                        <span>{h.label}</span>
                        <span className="text-cream-50">{h.value}</span>
                      </li>
                    ))}
                  </ul>
                </Row>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

function Row({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="grid gap-2 sm:grid-cols-[6.5rem,1fr] sm:items-start">
      <p className="text-xs font-medium uppercase tracking-[0.18em] text-blush-200">
        {label}
      </p>
      <div>{children}</div>
    </div>
  );
}
